import { Component, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute, RouterLink } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { BaseComponent } from '@core/components/base/base.component';
import { environment } from '@environment';
import { ToastrService } from '@core/services/notification/toastr.service';
import { GtmService } from '@app/core/services/analytics/gtm.service';
import { NgTemplateOutlet, NgClass } from '@angular/common';
import { DeferImageLoadDirective } from '../../../shared/directives/defer-image-load.directive';
import { FeatureToggleDirective } from '../../../shared/directives/feature-toggle.directive';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: true,
    imports: [FeatureToggleDirective, RouterLink, DeferImageLoadDirective, NgTemplateOutlet, NgClass]
})
export class FooterComponent extends BaseComponent {
    @ViewChild('footerRef', { static: true }) footerRef: ElementRef;

    currentYear: any = new Date().getFullYear();
    links: any;
    showFooter = true;
    code: any;
    socialLinks = [];
    brandFeatures = [];
    isEatClubApp = false;
    isMojoApp = false;
    isBox8App = false;
    isBox8Desktop = false;
    eatClubMobileShowFooterLinks = false;

    showAppDownloadOptions = false;
    appVersion: string;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private renderer: Renderer2,
        private gtmService: GtmService,
        private toastrService: ToastrService
    ) {
        super();
        this.links = environment.links;
        this.isMojoApp = environment.brand.id === 13;
        this.isBox8App = environment.brand.id === 1;
        this.isEatClubApp = environment.brand.id === 19;
        this.eatClubMobileShowFooterLinks = (this.isEatClubApp && this.isMobile) || !this.isEatClubApp;
        this.isBox8Desktop = this.isBox8App && !this.isMobile;
        this.appVersion = `v${environment.VERSION}`;
        this.subscribeNavigationEnd();

        this.getBrandCode();
        if (this.isBox8App && this.isMobile) {
            this.socialLinks = [
                {
                    url: this.links.share.fb.url,
                    image: environment.DEPLOY_URL + '/assets/images/social/facebook.svg'
                },
                {
                    url: this.links.share.twitter.url,
                    image: environment.DEPLOY_URL + '/assets/images/social/twitter.svg'
                },
                {
                    url: this.links.share.insta.url,
                    image: environment.DEPLOY_URL + '/assets/images/social/instagram.svg'
                }
            ];
        } else if (this.isBox8Desktop) {
            this.brandFeatures = [
                {
                    image: environment.DEPLOY_URL + '/assets/images/brand_features/download-black.svg',
                    heading: '1M+',
                    subheading: 'App Downloads'
                },
                {
                    image: environment.DEPLOY_URL + '/assets/images/brand_features/outlet-black.svg',
                    heading: '300+ Outlets',
                    subheading: 'In Mumbai, Delhi NCR, Bangalore, Hyderabad, Pune, Chennai & Kolkata'
                },
                {
                    image: environment.DEPLOY_URL + '/assets/images/brand_features/customers-black.svg',
                    heading: '20L+',
                    subheading: 'Satisfied Customers'
                }
            ];
        }
    }

    getBrandCode() {
        const codeText = this.staticText.app_offer.codeText;
        const words = codeText.split('|');
        this.code = (words.length > 0 ? words[0] : codeText).replace('Code: ', '');
    }

    showMWebFooter() {
        return (this.isMojoApp && this.isMobile) || this.isBox8App;
    }

    showSocialLinks() {
        return this.isBox8App && this.isMobile;
    }

    openSocialLink(url) {
        window.open(url);
    }

    subscribeNavigationEnd() {
        if (!this.isMobile) {
            this.showAppDownloadOptions = true;
            return;
        }

        this.router.events
            .pipe(
                filter(e => e instanceof NavigationEnd),
                map(() => {
                    let route = this.route;
                    let child = this.route;

                    while (child) {
                        if (child.firstChild) {
                            child = child.firstChild;
                            route = child;
                        } else {
                            child = null;
                        }
                    }

                    return route;
                })
            )
            .subscribe((e: any) => {
                this.showAppDownloadOptions = !!e.snapshot.data.showAppDownloadOptions;
            });
    }

    copyCode(event: Event, code) {
        const el = this.renderer.createElement('textarea');
        el.value = code;
        this.renderer.appendChild(document.body, el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        event.stopPropagation();
        this.toastrService.openSnackBar(`Copied! Coupon Code: ${code}`, 'OKAY');
    }

    openStoreLinks(url) {
        window.open(url);
    }

    appStoreEvent(store_link: string) {
        this.gtmService.logEventTracking('home_page', 'download_app', 'footer_promotion');
        window.open(store_link, '_blank');
    }
}
